import { createB2BAPI } from "../../../api/Interceptor";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import { Accordion, Autocomplete, Button, Checkbox, FileButton, Group, Input, Modal, PasswordInput, Tabs } from "@mantine/core";
import "./SignUpDetailsVendor.css";
import B2BSelect from "../../common/B2BSelect";
import { useContext, useEffect, useMemo, useState } from "react";
import _ from 'lodash';
import { useLocation } from "react-router-dom";
import notify from "../../../utils/Notification";
import { useNavigate } from "react-router-dom";
import states from "../../../utils/StatesAndDistricts.json";
import { useSearchParams } from 'react-router-dom';
import { Country, State, City } from 'country-state-city';
import { BASE_URL } from "../../../api/EndPoints";
import { Carousel } from "@mantine/carousel";
import { IconUpload } from "@tabler/icons-react";

const SignUpDetailsVendor = () => {
    const location = useLocation();
    const stateData = location.state;
    const [searchParams] = useSearchParams();
    const isMobile = useMediaQuery("(max-width: 767px)");
    const role = searchParams.get("vendor");

    // const initialCustomerState = { name: "", email: "", password: "", mobileNumber: "", currency: "INR", purchaseType: "", purchaseMode: "", creditLimit: "", creditBalance: "", creditDays: "", gstType: "", gstNumber: "", checkPrintName: "", assignedSalesman: "", salesManName: "", region: {}, regionId: "", activateLoyalty: "", approveStatus: "", status: "ACTIVE", postPacking: false, postDc: false, msmeCertificateNumber: "", panNumber: "", cinNumber: "", gst: "", pan: "", msme: "", legalEntity: "", contactPerson: "", designation: "", contactPersonPhoneNo: "", contactPersonAlternativePhoneNo: "", contactPersonEmail: "", contactPersonAlternativeEmail: "", bankName: "", branchName: "", accountHolderName: "", accountNumber: "", ifscCode: "", cancel: "", locations: { nickName: "", address1: "", address2: "", city: "", state: "", mobileNo: "", email: "", pincode: "", country: "INDIA", isPrimary: true, vendorId: "" } };
    // const initialAddressState = { address1: "", address2: "", city: "", state: "", pincode: "", mobileNo: "", nickName: "", email: "", country: "INDIA", isPrimary: false, customerId: "", transporterCharges: {}, transporterId: "", transporter: null, gstNo: "" };
    // const initialContactInfo = { contactPerson: "", designation: "", contactPersonPhoneNo: "", contactPersonAlternativePhoneNo: "", contactPersonEmail: "", contactPersonAlternativeEmail: "", };
    // const initialBankInfo = { bankName: "", branchName: "", accountHolderName: "", accountNumber: "", ifscCode: "", cancel: "" };

    const [customer, setCustomer] = useState({});
    const [address, setAddress] = useState({});
    const [contactInfo, setContactInfo] = useState({});
    const [bankInfo, setBankInfo] = useState({});
    const options = ["General Info", "Contact Info", "Address", "Bank Info"];
    const [selectedImage, setSelectedImage] = useState({});
    const [activeTab, setActiveTab] = useState(options[0]);
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });
    const [opened, { open, close }] = useDisclosure(false);
    const [vendorImage, setVendorImage] = useState(null);
    const [visitingCards, setVisitingCards] = useState([]);
    const [checked, setChecked] = useState(true);
    const [addresses, setAddresses] = useState([]);
    const B2B_API = createB2BAPI();
    const navigate = useNavigate();
    const [region, setRegion] = useState([]);
    const [salesman, setSalesman] = useState([]);
    const [salesManNameList, setSalesManNameList] = useState([]);
    const [vendorDetails, setVendorDetails] = useState([]);
    const [rowCount, setRowCount] = useState(5);
    const [transporter, setTransporter] = useState([]);
    const [errors, setErrors] = useState({});
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);


    useEffect(() => {
        const countryList = Country.getAllCountries().map(country => ({
            value: country.isoCode,
            label: country.name
        }));
        setCountries(countryList);
    }, []);

    useEffect(() => {
        if (address.country) {
            const stateList = State.getStatesOfCountry(address.country).map(state => ({
                value: state.isoCode,
                label: state.name
            }));
            setStates(stateList);
            setCities([]); // Reset cities when country changes
            setAddress(prev => ({ ...prev, state: "", city: "" }));
        } else {
            setStates([]); // Clear states if no country is selected
            setCities([]); // Clear cities if no country is selected
            setAddress(prev => ({ ...prev, state: "", city: "" }));
        }
    }, [address.country]);

    // Update cities when state changes
    useEffect(() => {
        if (address.country && address.state) {
            const cityList = City.getCitiesOfState(address.country, address.state).map(city => ({
                value: city.name,
                label: city.name
            }));
            setCities(cityList);
            setAddress(prev => ({ ...prev, city: "" }));
        } else {
            setCities([]); // Clear cities if no state is selected
            setAddress(prev => ({ ...prev, city: "" }));
        }
    }, [address.state]);


    const handleChange = (event, key) => {
        let { value, files, checked, type } = event.target;
        if (type === 'file') {
            const file = files[0];
            if (file) {
                setCustomer(prev => ({
                    ...prev,
                    [key]: file,
                }));
            }
            return;
        }
        if (value === "true") value = true;
        if (value === "false") value = false;
        if (key.includes('.')) {
            const [parent, child] = key.split('.');
            setCustomer(prev => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value,
                },
            }));
        } else {
            setCustomer(prev => ({
                ...prev,
                [key]: type === 'checkbox' ? checked : value,
                ...(key === 'gstNumber' && { approveStatus: value ? 'APPROVED' : 'DRAFT' }),
            }));
        }
        if (key === 'assignedSalesman' && salesManNameList[value]) {
            setCustomer(prev => ({
                ...prev,
                salesManName: salesManNameList[value],
            }));
        }
        setErrors(prevErrors => ({
            ...prevErrors,
            [key]: '',
        }));
    };

    const handleStateChange = (event) => {
        const value = event.target.value;
        setCustomer(prev => ({
            ...prev,
            locations: { ...prev.locations, state: value, city: '' },
        }));
        setCities(states[value] || []);
    };

    const handleCityChange = (event) => {
        const value = event.target.value;
        setCustomer(prev => ({
            ...prev,
            locations: { ...prev.locations, city: value },
        }));
    };

    const handleAddressChange = (event, key) => {
        const { value } = event.target;
        setAddress(prev => ({
            ...prev,
            [key]: value,
        }));
    };
    const handleAddressCountryChange = (event) => {
        const value = event.target.value;
        setAddress(prev => ({
            ...prev,
            country: value,
            state: '',
            city: '',
        }));
    };
    const handleAddressStateChange = (event) => {
        const value = event.target.value;
        setAddress(prev => ({
            ...prev,
            state: value,
            city: '',
        }));
        setCities(states[value] || []);
    };

    const handleAddressCityChange = (event) => {
        const value = event.target.value;
        setAddress(prev => ({
            ...prev,
            city: value,
        }));
    };


    const handleNext = () => {
        const currentIndex = options.indexOf(activeTab);
        if (currentIndex < options.length - 1) {
            setActiveTab(options[currentIndex + 1]);
        }
    };

    const handleBack = () => {
        const currentIndex = options.indexOf(activeTab);
        if (currentIndex > 0) {
            setActiveTab(options[currentIndex - 1]);
        }
    };

    // const fetchCustomerData = async () => {
    //     if (!customerId) return;
    //     try {
    //         const res = await B2B_API.get(`vendor/${customerId}`).json();
    //         const customerRes = res.response;
    //         setCustomer((prev) => ({
    //             ...prev,
    //             ...customerRes,
    //             regionId: customerRes?.regionId || "",
    //         }));
    //     } catch (error) {
    //         console.error("Error fetching customer data:", error);
    //     }
    // };

    // const fetchAddressData = async () => {
    //     try {
    //         const locationRes = await B2B_API.get(
    //             `vendorLocations?vendorId=${customerId}`
    //         ).json();
    //         const sortedAddresses = locationRes.response.sort((a, b) => {
    //             return b.isPrimary - a.isPrimary;
    //         });
    //         setAddresses(sortedAddresses);
    //         setCities(states[locationRes.response.state] || []);
    //     } catch (error) {
    //         console.error("Error fetching customer data:", error);
    //     }
    // };
    const fetchSalesman = async () => {
        try {
            const res = await B2B_API.get(`user/salesman`).json();
            const data = res.response;
            const options = data?.map((user) => ({
                value: user.userId,
                label: `${user.firstName + " " + user.lastName}`,
            }));
            setSalesman(options);
            setSalesManNameList(
                data?.reduce((acc, user) => {
                    acc[user.userId] = user.firstName + " " + user.lastName;
                    return acc;
                }, {})
            );
        } catch (error) {
            console.error("Error fetching customer data:", error);
        }
    };

    const fetchRegion = async () => {
        try {
            const res = await B2B_API.get(`region`).json();
            const data = res.response;
            const options = data.map((r) => ({ value: r.id, label: r.name }));
            setRegion(options);
        } catch (error) {
            console.error(error);
        }
    };

    const customerFields = [
        ...([{
            id: 1,
            name: "Company Name",
            fieldType: "textField",
            type: "text",
            onChange: (event) => handleChange(event, 'supplier'),
            value: customer?.supplier,
            category: "customer",
            errorMessage: "supplier",
            require: true
        }]),
        ...([{
            id: 2,
            name: "Contact Person Name",
            fieldType: "textField",
            type: 'text',
            onChange: (event) => handleChange(event, 'contactPerson'),
            value: customer?.contactPerson,
            category: "customer",
            errorMessage: "contactPerson",
            require: true
        }]),
        ...([{
            id: 4,
            name: "Mobile No",
            fieldType: "textField",
            type: 'text',
            onChange: (event) => handleChange(event, 'mobileNumber'),
            value: customer?.mobileNumber,
            category: "customer",
            errorMessage: "mobileNumber",
            require: true
        }]),
        ...([{
            id: 5,
            name: "Email",
            fieldType: "textField",
            type: 'text',
            onChange: (event) => handleChange(event, 'email'),
            value: customer?.email || '',
            category: "customer",
            errorMessage: "email",
            require: true
        }]),

        // isCreateCustomer && {
        //     id: 4,
        //     name: "Password",
        //     fieldType: "passwordField",
        //     type: 'password',
        //     onChange: (event) => handleChange(event, 'password'),
        //     value: customer?.password || '',
        //     category: "customer",
        //     errorMessage: "password",
        // },

        // {
        //   id: 9,
        //   name: "Credit Limit",
        //   fieldType: "textField",
        //   type: 'text',
        //   onChange: (event) => handleChange(event, 'creditLimit'),
        //   value: customer?.creditLimit,
        //   category: "customer"
        // },
        // {
        //   id: 10,
        //   name: "Credit Balance",
        //   fieldType: "textField",
        //   type: 'text',
        //   onChange: (event) => handleChange(event, 'creditBalance'),
        //   value: customer?.creditBalance,
        //   category: "customer"
        // },
        // {
        //   id: 11,
        //   name: "Credit days",
        //   fieldType: "textField",
        //   type: 'text',
        //   onChange: (event) => handleChange(event, 'creditDays'),
        //   value: customer?.creditDays,
        //   category: "customer"
        // },
        // {
        //   id: 12,
        //   name: "Check Print Name",
        //   fieldType: "textField",
        //   type: 'text',
        //   onChange: (event) => handleChange(event, 'checkPrintName'),
        //   value: customer?.checkPrintName,
        //   category: "customer"
        // },
        //         ...(isCreateCustomer ? [{
        //         id: 12,
        //         name: "Region",
        //         fieldType: "selectField",
        //         onChange: (event) => handleChange(event, 'regionId'),
        //         value: customer?.regionId || customer.region?.id,
        //         category: "customer",
        //         options: region,
        //         clearable: true,
        //         errorMessage: "region",
        //     }] : []),
        ...([{
            id: 13,
            name: "Status",
            value: customer?.status,
            onChange: (event) => handleChange(event, "status"),
            fieldType: "radio",
            type: "radio",
            className: "form-group status-container",
            placeholder: "Status",
            category: "customer",
            options: [
                { values: "ACTIVE", label: "ACTIVE" },
                { values: "INACTIVE", label: "INACTIVE" }
            ]
        }]),
        ...([{
            id: 14,
            name: "MSME Certificate Number",
            fieldType: "textField",
            type: 'text',
            onChange: (event) => handleChange(event, 'msmeCertificateNumber'),
            value: customer?.msmeCertificateNumber,
            category: "customer",
        }]),
        ...([{
            id: 15,
            name: "Legal Entity",
            fieldType: "selectField",
            onChange: (event) => handleChange(event, 'legalEntity'),
            value: customer?.legalEntity,
            category: "customer",
            options: ["Proprietorship", "Partnership", "Private Limited", 'LLP', "Public Limited"],
            clearable: true,
        }]),
        ...([{
            id: 16,
            name: "PAN Number",
            fieldType: "textField",
            type: 'text',
            onChange: (event) => handleChange(event, 'panNumber'),
            value: customer?.panNumber,
            category: "customer",
        }]),

        ...([{
            id: 17,
            name: "CIN Number",
            fieldType: "textField",
            type: 'text',
            onChange: (event) => handleChange(event, 'cinNumber'),
            value: customer?.cinNumber,
            category: "customer",
        }]),
        ...([{
            id: 18,
            name: "Aadhar Number",
            fieldType: "textField",
            type: 'text',
            onChange: (event) => handleChange(event, 'aadharNo'),
            value: customer?.aadharNo,
            category: "customer",
        }]),
        ...([{
            id: 23,
            name: "GST Certificate",
            fieldType: "file",
            type: 'text',
            onChange: (event) => handleChange(event, 'gst'),
            value: customer?.gst,
            category: "customer",
            button: {
                label: "View File",
                show: customer?.gstDocumentPath,
                onClick: (event) => {
                    downloadFile(customer?.gstDocumentPath)
                    if (customer?.gstDocumentPath) {
                        notify({
                            title: 'Success!',
                            message: res.message || 'File Download successful.',
                            error: false,
                            success: true,
                        });
                    } else {
                        notify({
                            title: 'OOPS!!!',
                            message: 'No File to Download !!!',
                            error: true,
                            success: false,
                        });
                    }
                }
            }
        }]),
        ...([{
            id: 24,
            name: "PAN Card Copy",
            fieldType: "file",
            type: 'text',
            onChange: (event) => handleChange(event, 'pan'),
            value: customer?.pan,
            category: "customer",
            button: {
                label: "View File",
                show: customer?.panDocumentPath,
                onClick: (event) => {
                    downloadFile(customer?.panDocumentPath)
                    if (customer?.panDocumentPath) {
                        notify({
                            title: 'Success!',
                            message: res.message || 'File Download successful.',
                            error: false,
                            success: true,
                        });
                    } else {
                        notify({
                            title: 'OOPS!!!',
                            message: 'No File to Download !!!',
                            error: true,
                            success: false,
                        });
                    }
                }
            }
        }]),
        ...([{
            id: 25,
            name: "MSME Certificate",
            fieldType: "file",
            type: 'text',
            onChange: (event) => handleChange(event, 'msme'),
            value: customer?.msme,
            category: "customer",
            button: {
                label: "View File",
                show: customer?.msmeDocumentPath,
                onClick: (event) => {
                    downloadFile(customer?.msmeDocumentPath)
                    if (customer?.msmeDocumentPath) {
                        notify({
                            title: 'Success!',
                            message: res.message || 'File Download successful.',
                            error: false,
                            success: true,
                        });
                    } else {
                        notify({
                            title: 'OOPS!!!',
                            message: 'No File to Download !!!',
                            error: true,
                            success: false,
                        });
                    }
                }
            }
        }]),
    ];
    const ContactInfo = useMemo(() => [
        {
            id: 1,
            name: "Contact Person Name",
            fieldType: "textField",
            type: 'text',
            onChange: (event) => handleChange(event, 'contactPerson'),
            value: customer?.contactPerson,
            category: "contactInfo",
            errorMessage: "supplier",
        },
        {
            id: 2,
            name: "Designation",
            fieldType: "textField",
            type: 'text',
            onChange: (event) => handleChange(event, 'designation'),
            value: customer?.designation,
            category: "contactInfo",
            errorMessage: "supplier",
        },
        {
            id: 3,
            name: "Mobile Number",
            fieldType: "textField",
            type: 'number',
            disabled: false,
            onChange: (event) => handleChange(event, 'contactPersonPhoneNo'),
            value: customer?.contactPersonPhoneNo,
            category: "contactInfo",
            require: true
        },
        {
            id: 4,
            name: "Alternate Mobile Number",
            fieldType: "textField",
            type: 'number',
            disabled: false,
            onChange: (event) => handleChange(event, 'contactPersonAlternativePhoneNo'),
            value: customer?.contactPersonAlternativePhoneNo,
            category: "contactInfo",
        },
        {
            id: 5,
            name: "Email",
            fieldType: "textField",
            type: 'text',
            onChange: (event) => handleChange(event, 'contactPersonEmail'),
            value: customer?.contactPersonEmail || '',
            category: "contactInfo",
        },

    ], [contactInfo, customer])


    const addressFields = [

        {
            id: 2,
            name: "Address 1",
            fieldType: "textField",
            type: 'text',
            disabled: false,
            onChange: (event) => handleAddressChange(event, 'address1'),
            value: address.address1,
            category: "address",
        },
        {
            id: 3,
            name: "Address 2",
            fieldType: "textField",
            type: 'text',
            disabled: false,
            onChange: (event) => handleAddressChange(event, 'address2'),
            value: address.address2,
            category: "address",
        },
        {
            id: 4,
            name: "Country",
            fieldType: "selectField2",
            onChange: (event) => handleAddressCountryChange(event),
            value: address?.country || '',
            category: "address",
            options: countries,
            clearable: false,
        },
        {
            id: 5,
            name: "State",
            fieldType: "selectField2",
            onChange: (event) => handleAddressStateChange(event),
            value: address?.state || '',
            category: "address",
            options: states,
            clearable: false,
        },
        {
            id: 6,
            name: "City",
            fieldType: "selectField2",
            onChange: (event) => handleAddressCityChange(event),
            value: address?.city || '',
            category: "address",
            options: cities,
            clearable: false,
        },
        {
            id: 7,
            name: "Email",
            fieldType: "textField",
            onChange: (event) => handleAddressChange(event, 'email'),
            value: address?.email || '',
            category: "address",
            clearable: false,
        },
        {
            id: 8,
            name: "Phone Number",
            fieldType: "textField",
            onChange: (event) => handleAddressChange(event, 'mobileNo'),
            value: address?.mobileNo || '',
            category: "address",
            clearable: false,
        },
        {
            id: 9,
            name: "Pin Code",
            fieldType: "textField",
            type: 'number',
            disabled: false,
            onChange: (event) => handleAddressChange(event, 'pincode'),
            value: address?.pincode,
            category: "address",
            maxLength: 6,
        },


    ]

    const BankInfo = useMemo(() => [
        {
            id: 1,
            name: "Bank Name",
            fieldType: "textField",
            type: 'text',
            onChange: (event) => handleChange(event, 'bankName'),
            value: customer?.bankName,
            category: "bankInfo",
            errorMessage: "supplier",
        },
        {
            id: 2,
            name: "Branch Name",
            fieldType: "textField",
            type: 'text',
            onChange: (event) => handleChange(event, 'branchName'),
            value: customer?.branchName,
            category: "bankInfo",
            errorMessage: "supplier",
        },
        {
            id: 3,
            name: "Account Holder Name",
            fieldType: "textField",
            type: 'text',
            disabled: false,
            onChange: (event) => handleChange(event, 'accountHolderName'),
            value: customer?.accountHolderName,
            category: "bankInfo",
            required: true
        },
        {
            id: 4,
            name: "Account Number",
            fieldType: "textField",
            type: 'text',
            disabled: false,
            onChange: (event) => handleChange(event, 'accountNumber'),
            value: customer?.accountNumber,
            category: "bankInfo",
            required: true
        },
        {
            id: 5,
            name: "IFSC Code",
            fieldType: "textField",
            type: 'text',
            onChange: (event) => handleChange(event, 'cancel'),
            value: customer?.cancel || '',
            category: "bankInfo",
            errorMessage: "Please upload the cancelled check",
        },
        {
            id: 6,
            name: "Cancelled Check Upload",
            fieldType: "file",
            type: 'text',
            onChange: (event) => handleChange(event, 'gst'),
            value: customer?.gst,
            category: "bankInfo",
            errorMessage: "supplier",
        },

    ], [bankInfo, customer])

    const handleSave = async (event) => {

        const vendorPayload = {
            ...customer,
            email: customer.email,
            password: customer.password,
            contactInfo: contactInfo || {},
            locations: address || {},
            bankInfo: bankInfo || {},
        };


        if (!vendorPayload.email) {
            notify({
                title: "Oops!",
                message: "Email is required",
                error: true,
            });

            return

        }

        if (vendorImage === null || !vendorImage) {
            notify({
                title: "Oops!",
                message: "Vendor Image is required",
                error: true,
            });

            return

        }
        if (visitingCards?.length < 1) {
            notify({
                title: "Oops!",
                message: "Business Cards are required",
                error: true,
            });

            return

        }
        if (!vendorPayload.supplier) {
            notify({
                title: "Oops!",
                message: "Company Name is required",
                error: true,
            });
            return
        }

        if (!vendorPayload.mobileNumber) {
            notify({
                title: "Oops!",
                message: "Mobilenumber is required",
                error: true,
            });
            return

        }
        const formData = new FormData();

        const fileFields = ["gst", "pan", "msme"];
        fileFields.forEach((field) => {
            const fileOrFiles = vendorPayload[field];
            if (fileOrFiles) {
                if (Array.isArray(fileOrFiles)) {
                    fileOrFiles.forEach((f) => formData.append(field, f));
                } else {
                    formData.append(field, fileOrFiles);
                }
                delete vendorPayload[field];
            }
        });

        if (vendorImage && typeof vendorImage !== "string") {
            formData.append("vendorImage", vendorImage);
        }

        if (visitingCards && visitingCards.length > 0) {
            visitingCards.forEach((file) => {
                if (typeof file !== "string") {
                    formData.append("businessCards", file);
                }
            });
        }


        try {
            formData.append(
                "vendorDto",
                new Blob([JSON.stringify(vendorPayload)], {
                    type: "application/json",
                })
            );

            const blob = formData.get("vendorDto");
            await blob.text().then(text => console.log("vendorDto JSON:", text));
            for (let [key, value] of formData.entries()) {
                if (value instanceof Blob) {
                    value.text().then(text => console.log("JSON content:", text));
                }
            }
            console.log(formData, "mkmmmkmkk")
            const customerResponse = await B2B_API.post("vendor/save", {
                body: formData,
            }).json();

            if (customerResponse.response?.id) {
                notify({
                    title: "Success!",
                    message: customerResponse.message || "Vendor saved successfully.",
                    success: true,
                });
                navigate("/login?role=vendor", {
                    state: {
                        email: customer.email,
                        password: customer.password,
                    },
                });

            } else {
                notify({
                    title: "Error!",
                    message: customerResponse.message || "Save failed.",
                    error: true,
                });
            }
        } catch (error) {
            notify({
                title: "Oops!",
                message: error.message || "Something went wrong.",
                error: true,
            });
        }
    };


    const handleCancel = () => {
        setIsCreateCustomer(false);
        setIsEditCustomer(false);
        setCustomerId("");
        setErrors("");
    };

    const handleEdit = (addr) => {
        setAddress(addr);
        open();
        setCities(states[addr?.state] || []);
    };

    const handleClose = () => {
        setAddress(initialAddressState);
        close();
    };

    return (
        <>
            <div className="signUpVendorBodyHead">
                <div style={{ display: "flex", justifyContent: "center", marginBottom: "30px", marginTop: "20px" }}>
                    <h1 className="signUpVendor">Seller Sign up</h1>
                </div>

                <div>
                    <Accordion
                        value={activeTab}
                        onChange={setActiveTab}
                        variant="separated"
                        styles={{
                            control: {
                                border: '1px solid #ccc',
                                padding: '0.5rem',

                            },
                            item: {
                                marginTop: '1rem',
                            },
                        }}
                    >
                        {options.map((item, index) => (
                            <Accordion.Item key={index} value={item}>
                                <Accordion.Control
                                    styles={{
                                        label: {
                                            fontSize: '20px',
                                            textAlign: 'center',
                                            fontWeight: 'bold',
                                            width: '100%',
                                            color: activeTab === item ? '#8BC53F' : 'black',

                                        },
                                        control: {
                                            border: activeTab === item ? '0px  solid #ccc' : '1px solid #ccc',
                                        },
                                    }}
                                >
                                    {item}
                                </Accordion.Control>
                                <Accordion.Panel>
                                    <div className="sign-up-vendor">
                                        {item === "General Info" && (
                                            <div className="customer-container">
                                                <div
                                                    className="profile-images-container"
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: isMobile ? "column" : "row",
                                                        gap: isMobile ? "1.5rem" : "2.5rem",
                                                        flexWrap: "wrap",
                                                    }}
                                                >
                                                    {/* Vendor Image (Profile Picture) */}
                                                    <div className="pv-images-left" style={{ minWidth: "300px" }}>
                                                        <label className="form-label" style={{ display: 'block', marginBottom: isMobile ? "0px" : '0.6rem' }}>
                                                            Vendor Image <span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <div className="pv-carousel-box" style={{
                                                            width: isMobile ? "100%" : 220,
                                                            maxWidth: isMobile ? "100%" : 220,
                                                            height: isMobile ? "100%" : 220,
                                                            padding: "1px",
                                                        }}>
                                                            {vendorImage ? (
                                                                <div className="pv-carousel-inner" style={{ position: 'relative' }}>
                                                                    <img
                                                                        src={typeof vendorImage === "string" ? vendorImage : URL.createObjectURL(vendorImage)}
                                                                        alt="Vendor"
                                                                        style={{ width: '100%', height: '100%', borderRadius: 8 }}
                                                                    />
                                                                    <Button
                                                                        size="xs"
                                                                        color="red"
                                                                        className="pv-remove-btn"
                                                                        style={{ position: 'absolute', top: 8, right: 8 }}
                                                                        onClick={() => setVendorImage(null)}
                                                                    >
                                                                        ✕
                                                                    </Button>
                                                                </div>
                                                            ) : (
                                                                <div className="pv-empty-placeholder" style={{
                                                                    height: '100%',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    border: '2px dashed #ccc',
                                                                    borderRadius: 8
                                                                }}>
                                                                    <IconUpload size={32} color="#999" />
                                                                    <div style={{ marginTop: 12, color: '#666' }}>Upload Vendor Image</div>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <Group justify="start" mt={isMobile ? "" : "sm"}>
                                                            <FileButton
                                                                onChange={(file) => setVendorImage(file)}
                                                                accept="image/png,image/jpeg,image/webp"
                                                            >
                                                                {(props) => (
                                                                    <Button {...props} variant="outline" color="green" size="sm">
                                                                        Upload Vendor Image
                                                                    </Button>
                                                                )}
                                                            </FileButton>
                                                        </Group>
                                                    </div>

                                                    {/* business Cards */}
                                                    <div className="pv-images-left">
                                                        <label className="form-label" style={{ display: 'block', marginBottom: isMobile ? "0px" : '0.6rem' }}>
                                                            Business Cards  <span style={{ color: "red" }}>*</span>

                                                        </label>
                                                        <div className="pv-carousel-box" style={{
                                                            width: isMobile ? "100%" : 220,
                                                            maxWidth: isMobile ? "100%" : 220,
                                                            height: isMobile ? "100%" : 220,
                                                            padding: "1px",
                                                        }}>
                                                            {visitingCards.length === 0 ? (
                                                                <div className="pv-empty-placeholder" style={{
                                                                    height: '100%',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    border: '2px dashed #ccc',
                                                                    borderRadius: 8
                                                                }}>
                                                                    <IconUpload size={32} color="#999" />
                                                                    <div style={{ display: "flex", justifyContent: "flex-start", marginTop: 12, color: '#666' }}>Upload Business cards</div>
                                                                </div>
                                                            ) : (
                                                                <Carousel
                                                                    withIndicators
                                                                    height={isMobile ? "100%" : 220}
                                                                    slideSize="100%"
                                                                    withControls={visitingCards.length > 1}
                                                                    loop
                                                                >
                                                                    {visitingCards.map((file, index) => (
                                                                        <Carousel.Slide key={index}>
                                                                            <div className="pv-carousel-inner" style={{ position: 'relative' }}>
                                                                                <img
                                                                                    src={typeof file === "string" ? file : URL.createObjectURL(file)}
                                                                                    alt={`Card ${index + 1}`}
                                                                                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8 }}
                                                                                />
                                                                                <Button
                                                                                    size="xs"
                                                                                    color="red"
                                                                                    className="pv-remove-btn"
                                                                                    style={{ position: 'absolute', top: 8, right: 8 }}
                                                                                    onClick={() => setVisitingCards(prev => prev.filter((_, i) => i !== index))}
                                                                                >
                                                                                    ✕
                                                                                </Button>
                                                                            </div>
                                                                        </Carousel.Slide>
                                                                    ))}
                                                                </Carousel>
                                                            )}
                                                        </div>
                                                        <Group justify="start" mt={isMobile ? "" : "sm"}>
                                                            <FileButton
                                                                multiple
                                                                accept="image/png,image/jpeg,image/webp"
                                                                onChange={(files) => setVisitingCards(prev => [...prev, ...files])}
                                                            >
                                                                {(props) => (
                                                                    <Button {...props} variant="outline" color="green" size="sm">
                                                                        Upload Business Cards
                                                                    </Button>
                                                                )}
                                                            </FileButton>
                                                        </Group>
                                                    </div>
                                                </div>
                                                <div className="customer-form-section">
                                                    {customerFields
                                                        .filter((field) => field.category === "customer")
                                                        .map((field) => (
                                                            <div key={field.id} className="form-row">
                                                                <label className="form-label">
                                                                    {field.name}
                                                                    {field.require ? <span style={{ color: "red" }}>*</span> : ''}
                                                                </label>
                                                                <div className="form-input">
                                                                    {field.fieldType === "textField" && (
                                                                        <>
                                                                            <Input
                                                                                value={field.value}
                                                                                className="input-textField"
                                                                                required
                                                                                type={field.type}
                                                                                placeholder={field.name}
                                                                                onChange={field.onChange}
                                                                                disabled={field.disabled}
                                                                                maxLength={field.maxLength}
                                                                            />
                                                                            {errors[field.errorMessage] && (
                                                                                <span className="error">
                                                                                    {errors[field.errorMessage]}
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {field.fieldType === "numberField" && (
                                                                        <>
                                                                            <Input
                                                                                value={field.value}
                                                                                className="input-numberField"
                                                                                required
                                                                                type={field.type}
                                                                                placeholder={field.name}
                                                                                onChange={field.onChange}
                                                                                disabled={field.disabled}
                                                                                maxLength={field.maxLength}
                                                                            />
                                                                            {errors[field.errorMessage] && (
                                                                                <span className="error">
                                                                                    {errors[field.errorMessage]}
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {field.fieldType === "mobileField" && (
                                                                        <>
                                                                            <Input
                                                                                type="mobile"
                                                                                name="mobileNumber"
                                                                                value={customer?.mobileNumber}
                                                                                placeholder={field.name}
                                                                                onChange={(e) => {
                                                                                    let val = e.target.value.replace(/\D/g, "");
                                                                                    if (val.length <= 10) {
                                                                                        handleChange({ target: { value: val } }, "mobileNumber");
                                                                                    }
                                                                                }}
                                                                                maxLength={10}
                                                                                pattern="\d{10}"
                                                                                required
                                                                            />
                                                                        </>
                                                                    )}
                                                                    {field.fieldType === 'passwordField' && (
                                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                            <PasswordInput
                                                                                className='input-textField'
                                                                                required
                                                                                size='md'
                                                                                placeholder="Your password"
                                                                                value={field.value}
                                                                                onChange={field.onChange}
                                                                                radius="sm"
                                                                            />
                                                                            {errors[field.errorMessage] && <span className="error">{errors[field.errorMessage]}</span>}
                                                                        </div>
                                                                    )}
                                                                    {field.fieldType === "selectField" && (
                                                                        <>
                                                                            <B2BSelect
                                                                                value={field.value || ""}
                                                                                styles={{ input: { fontSize: "14px" } }}
                                                                                data={field.options || []}
                                                                                placeholder={field.name}
                                                                                onChange={(value) =>
                                                                                    field.onChange({ target: { value } })
                                                                                }
                                                                                clearable={field.clearable}
                                                                                className="input-textField"
                                                                            />
                                                                            {errors[field.errorMessage] && (
                                                                                <span className="error">
                                                                                    {errors[field.errorMessage]}
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {field.fieldType === "radio" && (
                                                                        <div className="layout-fields-status-input">
                                                                            {field?.options.map((option, idx) => (
                                                                                <div
                                                                                    className="layout-fields-status-radio"
                                                                                    key={idx}
                                                                                >
                                                                                    <input
                                                                                        id={`${field.name}-${option.values.toString().toLowerCase()}`}
                                                                                        value={option.values}
                                                                                        onChange={(event) =>
                                                                                            field.onChange(
                                                                                                event,
                                                                                                field.name,
                                                                                                option?.values
                                                                                            )
                                                                                        }
                                                                                        checked={
                                                                                            String(field.value) ===
                                                                                            String(option.values)
                                                                                        }
                                                                                        type={field.type}
                                                                                    />
                                                                                    <label
                                                                                        className="form-span radio"
                                                                                        htmlFor={`${field.name}-${option.values.toString().toLowerCase()}`}
                                                                                    >
                                                                                        {option.label}
                                                                                    </label>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                    {field.fieldType === "file" && (
                                                                        <>
                                                                            <Input
                                                                                type="file"
                                                                                className="input-textField"
                                                                                onChange={field.onChange}
                                                                                disabled={field.disabled}
                                                                            />
                                                                            {errors[field.errorMessage] && (
                                                                                <span className="error">
                                                                                    {errors[field.errorMessage]}
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                        )}

                                        {item === "Contact Info" && (
                                            <div className="customer-container">
                                                <div className="customer-form-section">
                                                    {ContactInfo.filter((field) => field.category === "contactInfo")
                                                        .map((field) => (
                                                            <div key={field.id} className="form-row">
                                                                <label className="form-label2">
                                                                    {field.name}
                                                                    {field.require}
                                                                </label>
                                                                <div className="form-input">
                                                                    {field.fieldType === "textField" && (
                                                                        <>
                                                                            <Input
                                                                                value={field.value}
                                                                                className="input-textField"
                                                                                required
                                                                                type={field.type}
                                                                                placeholder={field.name}
                                                                                onChange={field.onChange}
                                                                                disabled={field.disabled}
                                                                                maxLength={field.maxLength}
                                                                            />
                                                                            {errors[field.errorMessage] && (
                                                                                <span className="error">
                                                                                    {errors[field.errorMessage]}
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {field.fieldType === "selectField" && (
                                                                        <>
                                                                            <B2BSelect
                                                                                value={field.value || ""}
                                                                                styles={{ input: { fontSize: "14px" } }}
                                                                                data={field.options || []}
                                                                                placeholder={field.name}
                                                                                onChange={(value) =>
                                                                                    field.onChange({ target: { value } })
                                                                                }
                                                                                clearable={field.clearable}
                                                                                className="input-textField"
                                                                            />
                                                                            {errors[field.errorMessage] && (
                                                                                <span className="error">
                                                                                    {errors[field.errorMessage]}
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {field.fieldType === "radio" && (
                                                                        <div className="layout-fields-status-input">
                                                                            {field?.options.map((option, idx) => (
                                                                                <div
                                                                                    className="layout-fields-status-radio"
                                                                                    key={idx}
                                                                                >
                                                                                    <input
                                                                                        id={`${field.name}-${option.values.toString().toLowerCase()}`}
                                                                                        value={option.values}
                                                                                        onChange={(event) =>
                                                                                            field.onChange(
                                                                                                event,
                                                                                                field.name,
                                                                                                option?.values
                                                                                            )
                                                                                        }
                                                                                        checked={
                                                                                            String(field.value) ===
                                                                                            String(option.values)
                                                                                        }
                                                                                        type={field.type}
                                                                                    />
                                                                                    <label
                                                                                        className="form-span radio"
                                                                                        htmlFor={`${field.name}-${option.values.toString().toLowerCase()}`}
                                                                                    >
                                                                                        {option.label}
                                                                                    </label>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                    {field.fieldType === "file" && (
                                                                        <>
                                                                            <Input
                                                                                type="file"
                                                                                className="input-textField"
                                                                                onChange={field.onChange}
                                                                                disabled={field.disabled}
                                                                            />
                                                                            {errors[field.errorMessage] && (
                                                                                <span className="error">
                                                                                    {errors[field.errorMessage]}
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                        )}

                                        {item === "Address" && (
                                            <div className="customer-container">
                                                <div className="customer-form-section">
                                                    {addressFields
                                                        .filter((field) => field.category === "address")
                                                        .map((field) => {
                                                            const sharedProps = {
                                                                value: field.value || "",
                                                                placeholder: field.name,
                                                                onChange:
                                                                    field.fieldType === "selectField"
                                                                        ? (value) => field.onChange({ target: { value: value || "" } })
                                                                        : field.onChange,
                                                                className: "input-textField",
                                                                disabled: field.disabled || false,
                                                                maxLength: field.maxLength,
                                                            };
                                                            return (
                                                                <div key={field.id} className="form-row">
                                                                    <label className="form-label3">
                                                                        {field.name}
                                                                        {field.require && <span className="required-asterisk">*</span>}
                                                                    </label>
                                                                    <div className="form-input">
                                                                        {field.fieldType === "textField" && (
                                                                            <>
                                                                                <Input
                                                                                    {...sharedProps}
                                                                                    type={field.type || "text"}
                                                                                    required={field.required}
                                                                                />
                                                                                {errors?.[field.errorMessage] && (
                                                                                    <span className="error">{errors[field.errorMessage]}</span>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                        {field.fieldType === "selectField2" && (
                                                                            <>
                                                                                <B2BSelect
                                                                                    value={field.value || ""}
                                                                                    styles={{ input: { fontSize: "14px" } }}
                                                                                    data={field.options || []}
                                                                                    placeholder={field.placeholder || field.name}
                                                                                    onChange={(value) =>
                                                                                        field.onChange({ target: { value } })
                                                                                    }
                                                                                    clearable={field.clearable}
                                                                                    className="input-textField"
                                                                                    disabled={field.disabled}
                                                                                />
                                                                                {errors[field.errorMessage] && (
                                                                                    <span className="error">
                                                                                        {errors[field.errorMessage]}
                                                                                    </span>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                        {field.fieldType === "selectField" && (
                                                                            <>
                                                                                <Autocomplete
                                                                                    {...sharedProps}
                                                                                    styles={{ input: { fontSize: "14px", height: "2.8rem" } }}
                                                                                    data={Array.isArray(field.options) ? field.options : []}
                                                                                    clearable={field.clearable || false}
                                                                                />
                                                                                {errors?.[field.errorMessage] && (
                                                                                    <span className="error">{errors[field.errorMessage]}</span>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                        {field.fieldType === "select" && (
                                                                            <>
                                                                                <Select
                                                                                    value={field.value || ""}
                                                                                    data={Array.isArray(field.options) ? field.options : []}
                                                                                    styles={{ input: { fontSize: "14px", height: "2.8rem" } }}
                                                                                    onChange={field.onChange}
                                                                                    placeholder={field.name}
                                                                                    className="input-textField"
                                                                                />
                                                                                {errors?.[field.errorMessage] && (
                                                                                    <span className="error">{errors[field.errorMessage]}</span>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        )}

                                        {item === "Bank Info" && (
                                            <div className="customer-container">
                                                <div className="customer-form-section">
                                                    {BankInfo.filter((field) => field.category === "bankInfo")
                                                        .map((field) => (
                                                            <div key={field.id} className="form-row">
                                                                <label className="form-label4">
                                                                    {field.name}
                                                                    {field.require}
                                                                </label>
                                                                <div className="form-input">
                                                                    {field.fieldType === "textField" && (
                                                                        <>
                                                                            <Input
                                                                                value={field.value}
                                                                                className="input-textField"
                                                                                required
                                                                                type={field.type}
                                                                                placeholder={field.name}
                                                                                onChange={field.onChange}
                                                                                disabled={field.disabled}
                                                                                maxLength={field.maxLength}
                                                                            />
                                                                            {errors[field.errorMessage] && (
                                                                                <span className="error">
                                                                                    {errors[field.errorMessage]}
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {field.fieldType === "selectField" && (
                                                                        <>
                                                                            <B2BSelect
                                                                                value={field.value || ""}
                                                                                styles={{ input: { fontSize: "14px" } }}
                                                                                data={field.options || []}
                                                                                placeholder={field.name}
                                                                                onChange={(value) =>
                                                                                    field.onChange({ target: { value } })
                                                                                }
                                                                                clearable={field.clearable}
                                                                                className="input-textField"
                                                                            />
                                                                            {errors[field.errorMessage] && (
                                                                                <span className="error">
                                                                                    {errors[field.errorMessage]}
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                    {field.fieldType === "radio" && (
                                                                        <div className="layout-fields-status-input">
                                                                            {field?.options.map((option, idx) => (
                                                                                <div
                                                                                    className="layout-fields-status-radio"
                                                                                    key={idx}
                                                                                >
                                                                                    <input
                                                                                        id={`${field.name}-${option.values.toString().toLowerCase()}`}
                                                                                        value={option.values}
                                                                                        onChange={(event) =>
                                                                                            field.onChange(
                                                                                                event,
                                                                                                field.name,
                                                                                                option?.values
                                                                                            )
                                                                                        }
                                                                                        checked={
                                                                                            String(field.value) ===
                                                                                            String(option.values)
                                                                                        }
                                                                                        type={field.type}
                                                                                    />
                                                                                    <label
                                                                                        className="form-span radio"
                                                                                        htmlFor={`${field.name}-${option.values.toString().toLowerCase()}`}
                                                                                    >
                                                                                        {option.label}
                                                                                    </label>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    )}
                                                                    {field.fieldType === "file" && (
                                                                        <>
                                                                            <Input
                                                                                type="file"
                                                                                className="input-textField"
                                                                                onChange={field.onChange}
                                                                                disabled={field.disabled}
                                                                            />
                                                                            {errors[field.errorMessage] && (
                                                                                <span className="error">
                                                                                    {errors[field.errorMessage]}
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                </div>
                                                <br />
                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
                                                    <div>
                                                        <Checkbox
                                                            color="#8BC53F"
                                                            checked={checked}
                                                            style={{ marginTop: '5px' }}
                                                            onChange={(event) => setChecked(event.currentTarget.checked)}
                                                        />
                                                    </div>
                                                    <div>
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <div>Get emails from FabInsta about product updates, industry news, and events</div>
                                                            <div>I have read the terms and conditions</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="line"></div>
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary btn-submit btn-block sign-up-button"
                                                    disabled={!checked}
                                                    onClick={handleSave}
                                                >
                                                    Sign Up
                                                </button>
                                                <div className="sign-in-button-wrapper">
                                                    Have an account ?
                                                    <a className="sign-in-button" href="/login?role=vendor">Sign in</a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </Accordion.Panel>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                    <br />
                    {/* {<div className='custBtn'>
                        {(activeTab === 'General Info' || activeTab === 'Bank Info' || activeTab === 'Contact Info' || activeTab === 'Address') && (
                            <>
                                {activeTab !== 'General Info' && <B2BButton name='Back' onClick={handleBack} color='red' leftSection={<IconArrowNarrowLeft stroke={2} />} />}
                                {activeTab !== 'Bank Info' && <B2BButton type='button' onClick={handleNext} color='blue' name={"Next"} style={{ marginLeft: 10 }} rightSection={<IconArrowNarrowRight stroke={2} />} />}
                            </>
                        )}
                    </div>} */}
                </div>
            </div>
        </>
    );
};

export default SignUpDetailsVendor;
